import axios from 'axios';

import authenticator    from './authenticator';
import requestFormatter from './requestFormatter';

const attachAuthHeader = (config) => {

    var sessionToken = authenticator.getSessionToken();

    if (sessionToken) {

        config.headers['Authorization'] = requestFormatter.getAuthorizationHeader(sessionToken);
    }

    return config;
};

const isTokenRefreshRequired = (config) => {

    return config.url !== '/api/v1/session/refresh' &&
        config.url !== '/api/v1/login' &&
        authenticator.isRefreshRequired()
};

const setRequestHeaders = (config) => {

    return new Promise((resolve) => {

        if (!authenticator.isSessionExpired() && authenticator.getSession()) {

            if (isTokenRefreshRequired(config)) {

                if (authenticator.isTokenRefreshing()) {

                    authenticator.onTokenRefresh(() => {

                        resolve(attachAuthHeader(config));
                    });

                } else {

                    authenticator.refreshToken()
                        .then(() => {

                            resolve(attachAuthHeader(config))
                        });
                }

            } else {

                resolve(attachAuthHeader(config));
            }

        } else {

            resolve(config);
        }
    });
};

const redirectOnUnauthorized = (error) => {

    if (error.statusText === 'Unauthorized') {

        window.location = '/login';
    }

    return Promise.reject(error);
};

axios.interceptors.request.use(setRequestHeaders, (error) => {

    return Promise.reject(error);
});

axios.interceptors.response.use((response) => response, redirectOnUnauthorized);

export default axios;


// WEBPACK FOOTER //
// ./services/http.js